export default "__VITE_ASSET__BUAtMFnF__"